import { Row, Col, CardImg } from "react-bootstrap";

const ModalProfileImage = ({ viewimage }) => {
    return (
        <Row className='my-2 mb-3'>
            <Col lg="4" xs={4} className=' mx-auto text-center'>
                <img src={viewimage} alt='Not image' style={{ width: "100px", aspectRatio: '1/1', objectFit: 'cover', height: "100px", borderRadius: "50%" }} />
            </Col>
        </Row>
    );
}

export default ModalProfileImage;

export const UploadImageViewer = ({ viewimage }) => {
    return (
        <Row className=''>
            <Col lg="8" xs={6} className=' mx-auto text-center'>
                <CardImg src={viewimage} alt='Not image' style={{ aspectRatio: '16/9', objectFit: 'contain', height: 'auto' }} />
            </Col>
        </Row>
    )
}
